export default __webpack_public_path__ + "987a2552789915fe9f254e1a9aa9d91c.svg";